<wtf-dialogcontent [size]="'md'" [dialogTitle]="dialogTitle" (closeModal)="dialogRef.close()" [action]="action">
    <form name="contactForm" [formGroup]="contactForm" class="tax-type-form w-100-p" fxLayout="column" fxFlex>
        <div fxLayout="row" fxLayoutAlign="end center">
            <mat-label>{{ "*Campos Obligatorios" | translate }}</mat-label>
        </div>
        <mat-label>{{ "Nombre del Contacto" | translate }}*</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="name" formControlName="name" mat-maxlength="50" placeholder="" required />
        </mat-form-field>
        <mat-label>{{ "Rol" | translate }}*</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="role" formControlName="role" mat-maxlength="50" placeholder="" required />
        </mat-form-field>
        <mat-label>{{ "Correo Electrónico" | translate }}*</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="email" formControlName="email" mat-maxlength="50" placeholder="" required />
        </mat-form-field>
        @if(isControlValid(contactForm, "email")){
        <div class="text-danger ng-mt-2">
            {{ getErrorMessage(contactForm, "email", "Correo Electrónico") }}
        </div>
        }
        <mat-label class="mt-4">{{ "Número de Teléfono" | translate }}*</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="phoneNumber" formControlName="phoneNumber" mat-maxlength="50" placeholder=""
                required />
        </mat-form-field>
        @if(isControlValid(contactForm, "phoneNumber")){
        <div class="text-danger ng-mt-2">
            {{ getErrorMessage(contactForm, "phoneNumber", "Número de Teléfono") }}
        </div>
        }
        <div fxLayout="row" fxLayoutAlign="end end">
            <button mat-raised-button (click)="saveContact()" class="submit-button" [disabled]="contactForm.invalid"
                aria-label="Guardar">
                <span class="material-icons-outlined"> save </span>
                <span> {{ "Guardar" | translate }}</span>
            </button>
        </div>
    </form>
</wtf-dialogcontent>